//import React from 'react';
const PAGE = [
  {
    //NUM 0
    "content": "Forgot Password?"
  },
  {
    //NUM 1
    "content": "Reset Password"
	}
];




	
export default PAGE;